import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../components/LoadingScreen"
import Table from "../components/Table";
import useHttpUtility from "../utilities/useHttpUtility";

export default function PageWindows() {

    const navigate = useNavigate();
    const http = useHttpUtility();

    const [data, setData] = useState(null);

    useEffect(() => {
        http.get("/api/Windows/Groups", setData);
    }, []);

    return (
        !data
            ? <LoadingScreen />
            :
            <div className="page page-windows">
                <h2>Delivery Window Groups</h2>
                <Table
                    data={data}
                    mappings={
                        [
                            {
                                header: "Name",
                                field: "name"
                            },
                            {
                                header: "Type",
                                field: "groupType",
                                dataType: "groupType"
                            },
                            {
                                header: "Active",
                                field: "active"
                            }
                        ]
                    }
                    pageSize={20}
                    onClick={(idx) => navigate(`${data[idx].id}${window.location.search}`)}
                    onClickAdd={() => navigate(`0${window.location.search}`)} />
            </div>
    );
}